import { Swiper } from './swiper';

const caseStudyCardsCarouselSwiper = new Swiper('.case-study-carousel__swiper-container', {
    loop: false,
    navigation: {
        nextEl: ".case-study-carousel-next",
        prevEl: ".case-study-carousel-prev",
    },
    spaceBetween: 16,
    slidesPerView: "auto",
    breakpoints: {
      // when window width is >= 640px
        640: {
            spaceBetween: 24,
        },
        1400: {
            spaceBetween: 40,
        },
    },
});
